import { FC } from "react";
import { IconPropsType } from ".";

export const GuestRequest: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66699 8V7.33333C4.66699 6.96514 4.36852 6.66667 4.00033 6.66667C3.63214 6.66667 3.33366 6.96514 3.33366 7.33333V8C3.33366 8.36819 3.63214 8.66667 4.00033 8.66667C4.36852 8.66667 4.66699 8.36819 4.66699 8ZM4.00033 6C3.26395 6 2.66699 6.59695 2.66699 7.33333V8C2.66699 8.73638 3.26395 9.33333 4.00033 9.33333C4.73671 9.33333 5.33366 8.73638 5.33366 8V7.33333C5.33366 6.59695 4.73671 6 4.00033 6Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99967 13.7333V12.6667C5.99967 11.5621 5.10424 10.6667 3.99967 10.6667C2.89511 10.6667 1.99967 11.5621 1.99967 12.6667V13.7333C1.99967 13.8806 2.11907 14 2.26634 14H5.73301C5.88028 14 5.99967 13.8806 5.99967 13.7333ZM3.99967 10C2.52692 10 1.33301 11.1939 1.33301 12.6667V13.7333C1.33301 14.2488 1.75088 14.6667 2.26634 14.6667H5.73301C6.24847 14.6667 6.66634 14.2488 6.66634 13.7333V12.6667C6.66634 11.1939 5.47243 10 3.99967 10Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33301 4.66663V2.66663H4.99967V4.19522L5.64959 3.54531C6.2122 2.9827 6.97526 2.66663 7.77091 2.66663H8.66634V3.33329H7.77091C7.15207 3.33329 6.55858 3.57913 6.12099 4.01671L5.47108 4.66663H6.66634V5.33329H4.99967C4.63148 5.33329 4.33301 5.03482 4.33301 4.66663Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.33337V2.66671C12 2.29852 11.7015 2.00004 11.3333 2.00004C10.9651 2.00004 10.6667 2.29852 10.6667 2.66671V3.33337C10.6667 3.70156 10.9651 4.00004 11.3333 4.00004C11.7015 4.00004 12 3.70156 12 3.33337ZM11.3333 1.33337C10.597 1.33337 10 1.93033 10 2.66671V3.33337C10 4.06975 10.597 4.66671 11.3333 4.66671C12.0697 4.66671 12.6667 4.06975 12.6667 3.33337V2.66671C12.6667 1.93033 12.0697 1.33337 11.3333 1.33337Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3337 9.06671V8.00004C13.3337 6.89547 12.4382 6.00004 11.3337 6.00004C10.2291 6.00004 9.33366 6.89547 9.33366 8.00004V9.06671C9.33366 9.21398 9.45305 9.33337 9.60033 9.33337H13.067C13.2143 9.33337 13.3337 9.21398 13.3337 9.06671ZM11.3337 5.33337C9.8609 5.33337 8.66699 6.52728 8.66699 8.00004V9.06671C8.66699 9.58217 9.08486 10 9.60033 10H13.067C13.5825 10 14.0003 9.58217 14.0003 9.06671V8.00004C14.0003 6.52728 12.8064 5.33337 11.3337 5.33337Z"
        fill={props.color}
      />
    </svg>
  );
};
